import { View } from './view';
import { Product } from '../config/product';
import { Translations } from '../config/translations';
import { Config } from '../config';
import { Util } from '../config/utils';

export class ProductView extends View {

    private config: Config = {};
    multiProdContainer: HTMLElement = document.createElement('form');

    setConfig(config: Config) {
        this.config = config;
    }

    shouldDisplayProductsAsRadioButtons(): boolean {
        return this.config &&
            this.config.settings &&
            this.config.settings.displayProductsAsRadioButtons &&
            this.config.settings.displayProductsAsRadioButtons === true;
    }

    renderMultipleProducts(products: Product[], onProductChange: any) {
        if (this.shouldDisplayProductsAsRadioButtons()) {
            this.renderProductsAsRadioButtons(products, onProductChange);
        } else {
            this.renderProductsAsDropdown(products, onProductChange);
        }
    }

    renderProductsAsRadioButtons(products: Product[], onProductChange: any) {
        let radioButtons = '';
        let counter = 1;
        for (const product of products) {
            radioButtons +=
                `<div class="df-product-radio-btn-group">
                    <input
                        df_product_id="${product.dfProductId || ''}"
                        id="${product.name}_${product.amount}"
                        type="radio"
                        product_type="${product.type}"
                        class="df-product-radio-btn"
                        name="df-product-radio-btn"
                        value="${product.amount}"
                        product_name="${product.name}"
                        ${counter === 1 ? 'checked' : ''}
                    />
                    <label class="df-product-radio-btn-label" for="${product.name}_${product.amount}">${product.name}</label>
                    <span class="df-product-radio-btn-total">${this.formatMoney(product.amount.toString(), this.config.settings.currency)}</span>
                </div>`;
                counter++;
        }

        this.multiProdContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-multiple-products');
        this.multiProdContainer.innerHTML =
            `<fieldset class="form-columns-1 df-fieldset">
                 <div class="field hs-form-field df-field">
                    <label>
                        <span class="df-f-label" data-label="multiple_products">${Translations.MULTIPLE_PRODUCTS}</span>
                        <span class="hs-form-required">*</span>
                    </label>
                    <div id="df_products" class="input hs-input">
                        ${radioButtons}
                   </div>
               </div>
            </fieldset>`;
        const container = this.getDFContainer();
        container.appendChild(this.multiProdContainer);

        this.addRadioButtonEventListeners(onProductChange);
    }

    addRadioButtonEventListeners(onProductChange: any) {
        // Add radio button group events.
        const radioButtonGroupElements = document.querySelectorAll('#df_products .df-product-radio-btn-group');
        radioButtonGroupElements.forEach(element => {
            (element as HTMLInputElement).onclick = (event: Event) => {
                const target = event.target as HTMLElement;
                const radioButton = target.querySelector('input.df-product-radio-btn') as HTMLSelectElement;
                if (radioButton) {
                    radioButton.click();
                }
            };
        });

        // Add radio button input events.
        const radioButtonInputElements = document.querySelectorAll('#df_products input.df-product-radio-btn');
        radioButtonInputElements.forEach(element => {
            (element as HTMLInputElement).onchange = (event: Event) => {
                const target = event.target as HTMLSelectElement;
                onProductChange({
                    name: target.getAttribute('product_name'),
                    value: target.value
                });
            };
        });


        // Add radio button amount events.
        const radioButtonAmountElements = document.querySelectorAll('#df_products .df-product-radio-btn-total');
        radioButtonAmountElements.forEach(element => {
            (element as HTMLInputElement).onclick = (event: Event) => {
                const target = event.target as HTMLElement;
                const radioButton = (target.parentElement as HTMLElement).querySelector('input.df-product-radio-btn') as HTMLSelectElement;
                if (radioButton) {
                    radioButton.click();
                }
            };
        });
    }

    renderProductsAsDropdown(products: Product[], onProductChange: any) {
        let options = '';
        for (const product of products) {
            options +=
                `<option
                    type="${product.type}"
                    df_product_id="${product.dfProductId || ''}"
                    product_type="${product.type}"
                    value="${product.amount}"
                    name="${product.name}"
                    product_name="${product.name}"
                >
                    ${product.name}
                </option>`;
        }
        this.multiProdContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-multiple-products');

        this.multiProdContainer.innerHTML =
            `<fieldset class='form-columns-1 df-fieldset'>
                <div class='field hs-form-field df-field'>
                    <label>
                        <span class='df-f-label' data-label="multiple_products">${Translations.MULTIPLE_PRODUCTS}</span>
                        <span class='hs-form-required'>*</span>
                    </label>
                    <div>
                        <select class='input hs-input df-select' id='df_products'>${options}</select>
                    </div>
                </div>
            </fieldset>`;
        const container = this.getDFContainer();
        container.appendChild(this.multiProdContainer);

        const element = document.querySelector(`#df_products`) as HTMLSelectElement;
        element.onchange = (event: Event) => {
            const target = event.target as HTMLSelectElement;
            const option = target.options[target.selectedIndex];
            onProductChange({
                name: option.getAttribute('product_name'),
                value: option.value
            });
        };
    }

    preselectDfProductId() {
        const preselectedDfProductId = Util.getUrlParameter('dfpr', window.location.href) || '';
        if (!preselectedDfProductId) {
            return;
        }
        if (this.shouldDisplayProductsAsRadioButtons()) {
            this.preselectRadioButtonDfProductId(preselectedDfProductId);
        } else {
            this.preselectDropdownDfProductId(preselectedDfProductId);
        }
    }

    preselectRadioButtonDfProductId(preselectedDfProductId: string) {
        const dfProductsElement = document.querySelectorAll('#df_products input[type="radio"]');
        dfProductsElement.forEach(dfProductElement => {
            const dfProductId = dfProductElement.getAttribute('df_product_id') || '';
            if (dfProductId === preselectedDfProductId) {
                (dfProductElement as HTMLInputElement).click();
            }
        });
    }

    preselectDropdownDfProductId(preselectedDfProductId: string) {
        const dfProductsElement = document.querySelector('#df_products') as HTMLSelectElement;
        const options = dfProductsElement.options as HTMLOptionsCollection;
        for (let i = 0; i < options.length; i++) {
            const dfProductId = options[i].getAttribute('df_product_id') || '';
            if (dfProductId === preselectedDfProductId) {
                dfProductsElement.selectedIndex = options[i].index;
                dfProductsElement.dispatchEvent(new CustomEvent('change', {}));
                break;
            }
        }
    }

    getSelectedProduct () {
        if (this.shouldDisplayProductsAsRadioButtons()) {
            return document.querySelector('input[name="df-product-radio-btn"]:checked');
        } else {
            const prods: any = document.getElementById(`df_products`);
            if (!prods) {
                return;
            }
            return prods.options[prods.selectedIndex];
        }
    }

     hideForm() {
        this.multiProdContainer.style.display = 'none';
    }

    showForm() {
        this.multiProdContainer.style.display = 'inherit';
    }

}
